import { GlobalAxios } from "../axios/axios-config";
import { ISyncTransactionActionWithLog } from "../models/sync-transaction-action-with-log";

const SYNC_TRANSACTION_ACTION_WITH_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/SyncTransaction/ActionWithLog";

export const getSyncTransactionActionWithLog = (params: {
  identifier: number;
  pageNumber: number;
  pageSize: number;
}) => {
  return GlobalAxios.get<ISyncTransactionActionWithLog>(
    SYNC_TRANSACTION_ACTION_WITH_LOG_ROUTE,
    {
      params,
    },
  );
};
